module.exports = __webpack_public_path__ + "6195da8759cd447cb1be2f8ebe4b7325.svg";